var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_662_9735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.71679 22.6077C8.35471 22.2591 7.78197 22.2212 7.40564 22.5544L7.34413 22.6088C6.93318 22.9727 6.89316 23.6039 7.28664 23.9866C7.32213 24.0211 7.35781 24.0554 7.39368 24.0895C7.79138 24.468 8.42073 24.4035 8.76834 23.9785L8.82034 23.915C9.13832 23.5263 9.07857 22.956 8.71679 22.6077Z",
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52613 19.706C6.29093 19.2606 5.75785 19.0444 5.29497 19.2431L5.22179 19.2745C4.71851 19.4905 4.48231 20.0757 4.73542 20.5614C4.76016 20.6089 4.78518 20.6562 4.81049 20.7033C5.06924 21.1855 5.68507 21.3199 6.14689 21.0264L6.21407 20.9838C6.63922 20.7136 6.76133 20.1515 6.52613 19.706Z",
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3257 2.80566C21.2868 1.62352 18.9719 1.00062 16.6151 1C9.91169 1.01078 4.24836 5.97505 3.35966 12.6193L1.71251 10.9721C1.32533 10.585 0.697596 10.585 0.31042 10.9721C-0.0767566 11.3593 -0.0767566 11.9871 0.31042 12.3742L4.22035 16.2842L8.74726 12.3944C9.2002 12.0052 9.22637 11.3129 8.8041 10.8907C8.44725 10.5338 7.88391 10.4894 7.47559 10.786L5.41024 12.2861C6.57553 6.10377 12.532 2.03669 18.7144 3.20198C24.8967 4.36727 28.9638 10.3237 27.7985 16.506C26.6332 22.6883 20.6767 26.7555 14.4944 25.5902C13.552 25.4125 12.6371 25.1169 11.771 24.711C11.2756 24.4789 10.671 24.6355 10.396 25.1086C10.1206 25.5824 10.2812 26.1939 10.7742 26.4335C17.0237 29.4696 24.6513 27.2074 28.192 21.1005C31.9003 14.7048 29.7215 6.51385 23.3257 2.80566Z",
    fill: "#E9A5F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1205 5.46191C15.5729 5.46191 15.1289 5.90586 15.1289 6.45349V15.8735C15.1289 16.1856 15.2759 16.4795 15.5255 16.6667L18.6986 19.0465C19.1367 19.3751 19.7582 19.2863 20.0868 18.8482C20.4154 18.4101 20.3266 17.7886 19.8885 17.46L17.4366 15.6211C17.2323 15.4679 17.1121 15.2274 17.1121 14.972V6.45349C17.1121 5.90586 16.6681 5.46191 16.1205 5.46191Z",
    fill: "#E9A5F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_662_9735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuration);
export default __webpack_public_path__ + "static/media/duration.3b25475e57ecc4ba0b4627d2c4bdb581.svg";
export { ForwardRef as ReactComponent };